// SEO por página con hoisting nativo de React 19 (sin librerías externas).
// React 19 eleva <title>, <meta> y <link> al <head> automáticamente.
// Nota: los tags og:* / twitter:* se dejan como defaults del sitio en index.html
// (los lee el scraper social sin ejecutar JS). Aquí manejamos los tags únicos
// por página relevantes para buscadores: título, descripción y canonical.
const SITE = "https://ludesign.com.mx";

export const Seo = ({ title, description, path = "" }) => {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} | Lu Design` : "Lu Design | Diseño que conecta e inspira";

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </>
  );
};

export default Seo;
